<tg-row class="summary-page-auction-details-section__header">
  <tg-col md="6" sm="12">
    <p class="p-lead-copy">Auction details</p>
  </tg-col>
  <tg-col md="6" sm="12" class="summary-page-auction-details-section__header--right">
    <a routerLink="../{{ stepIds.listingDetails }}" routerLinkActive="active" class="h-link-no-visited">
      {{summarySectionLinkText}} auction details
    </a>
  </tg-col>
</tg-row>
@if (isAuction === true) {
  <tg-row>
    <tg-col lg="6" sm="12" class="summary-page-auction-details-section__content">
      <span class="summary-page-auction-details-section__content-label">Start price:</span>
      {{ startPrice }}
    </tg-col>
    <tg-col lg="6" sm="12" class="summary-page-auction-details-section__content">
      <span class="summary-page-auction-details-section__content-label">Reserve:</span>
      {{ reservePrice }}
    </tg-col>
  </tg-row>
}
<tg-row>
  <tg-col sm="12" class="summary-page-auction-details-section__content">
    <span class="summary-page-auction-details-section__content-label">Buy Now:</span>
    {{ buyNowPrice }}
  </tg-col>
</tg-row>
@if (authenticatedUsersOnly === true) {
  <tg-row>
    <tg-col sm="12" class="summary-page-auction-details-section__content">
      Only authenticated users can bid on your auction
    </tg-col>
  </tg-row>
}
<tg-row>
  <tg-col sm="12" class="summary-page-auction-details-section__content">
    <span class="summary-page-auction-details-section__content-label">Duration:</span>
    {{ duration }}
  </tg-col>
</tg-row>
<tg-row>
  <tg-col sm="12" class="summary-page-auction-details-section__content">
    <span class="summary-page-auction-details-section__content-label">Package option:</span>
    {{ packageOption }}
  </tg-col>
</tg-row>
<tg-row>
  <tg-col sm="12" class="summary-page-auction-details-section__content">
    <span class="summary-page-auction-details-section__content-label">Vehicle transfer option:</span>
    {{ vehicleTransferOptions }}
  </tg-col>
</tg-row>
<tg-row>
  <tg-col sm="12" class="summary-page-auction-details-section__content">
    <span class="summary-page-auction-details-section__content-label">Accepted payment:</span>
    {{ acceptedPayment }}
    @if (acceptedPayments_Other) {
      <div>{{ otherPayment }}</div>
    }
  </tg-col>
</tg-row>